module.exports = __webpack_public_path__ + "static/media/fk-f3-01.3a99ca9d.png";